module.exports = __webpack_public_path__ + "static/media/UNDER.c62bbb37.png";